import React from "react";
import Header from "../components/header/Header";
import ProgressBar from "../components/progressBar/ProgressBar";
import PasswordlessLogin from "../components/auth/PasswordlessLogin";
import { CREATION_STEPS } from "../components/options/OptionParts";

function LoginWorkflow() {
  return (
    <PasswordlessLogin
      header={
        <>
          <Header />
          <ProgressBar steps={CREATION_STEPS} currentStep="Propriétaire" />
        </>
      }
      otpPath="/otp"
      signupPath="/owner-information"
    />
  );
}

export default LoginWorkflow;
